<div class="mc-wrap" (click)="$event.stopPropagation()">
  <button type="button" class="mc-trigger" [class.mc-trigger--open]="open"
          cdkOverlayOrigin #trigger="cdkOverlayOrigin"
          [attr.aria-expanded]="open" aria-haspopup="listbox"
          (click)="toggleOpen($event)">
    <span class="mc-trigger__label" [class.mc-trigger__label--empty]="!selected.size">{{ buttonLabel }}</span>
    <span class="mc-trigger__count" *ngIf="selected.size">{{ selected.size }}</span>
    <i class="fas fa-chevron-down mc-trigger__chevron" [class.mc-trigger__chevron--open]="open"></i>
  </button>
</div>

<!--
    The panel goes through a CDK overlay rather than sitting absolutely inside
    the trigger. Screens wrap this in `.card { overflow: hidden }`, which clips
    an in-flow panel to the bottom of the card — no z-index escapes that, and
    the Teaching profile card cut the class list off mid-list. The overlay is
    attached at body level, flips above the trigger when there is no room
    below, and is pushed back into the viewport rather than overflowing it.
-->
<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="open"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayMinWidth]="triggerWidth"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayPush]="true"
    (overlayOutsideClick)="onOutsideClick($event)"
    (detach)="open = false">
  <div class="mc-panel" role="listbox" aria-multiselectable="true">
    <div class="mc-search">
      <i class="fas fa-search"></i>
      <input type="text" [(ngModel)]="filterText" placeholder="Search classes..." />
      <button type="button" class="mc-clear" *ngIf="selected.size" (click)="clearAll($event)">Clear</button>
    </div>
    <div class="mc-tree">
      @if (filteredNodes.length === 0) {
        <div class="mc-empty">No classes found</div>
      }
      <ng-container *ngTemplateOutlet="treeLevel; context: { nodes: filteredNodes, depth: 0 }"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #treeLevel let-nodes="nodes" let-depth="depth">
  @for (node of nodes; track node.text) {
    <div>
      <div class="mc-node"
           [class.mc-node--leaf]="isLeaf(node)"
           [style.padding-left.rem]="0.75 + depth * 1">
        @if (!isLeaf(node)) {
          <button type="button" class="mc-node__expander" (click)="toggleExpand(node, $event)">
            <i class="fas" [class.fa-caret-right]="!isExpanded(node)" [class.fa-caret-down]="isExpanded(node)"></i>
          </button>
          <span class="mc-check"
                [class.mc-check--on]="branchState(node) === 'all'"
                [class.mc-check--some]="branchState(node) === 'some'"
                (click)="toggleBranch(node, $event)">
            <i class="fas fa-check" *ngIf="branchState(node) === 'all'"></i>
            <i class="fas fa-minus" *ngIf="branchState(node) === 'some'"></i>
          </span>
          <span class="mc-node__text" (click)="toggleExpand(node, $event)">{{ node.text }}</span>
        } @else {
          <span class="mc-node__spacer"></span>
          <span class="mc-check" [class.mc-check--on]="isChecked(node)" (click)="toggleLeaf(node, $event)">
            <i class="fas fa-check" *ngIf="isChecked(node)"></i>
          </span>
          <span class="mc-node__text" (click)="toggleLeaf(node, $event)">{{ node.text }}</span>
        }
      </div>
      @if (!isLeaf(node) && isExpanded(node)) {
        <ng-container *ngTemplateOutlet="treeLevel; context: { nodes: node.children, depth: depth + 1 }"></ng-container>
      }
    </div>
  }
</ng-template>
